import _ from 'lodash';

import { route } from '../helpers';
import urls from '../../urls';
import { JourneyPlannerLayout, JourneyPlannerLayoutTrackingName, GridPages, PointStages } from '../../constants/AppConstants';
import SearchActions from '../../actions/SearchActions';
import TripActions from '../../actions/TripActions';
import JourneyStore from '../../stores/JourneyStore';
import UserStore from '../../stores/UserStore';
import CurrentTripStore from '../../stores/CurrentTripStore';
import { openInAppVersionEndingModal } from '../../helpers/InAppModal';
import { InvalidSearchError } from '../../errors/Search';

export default route(GridPages.SERVICES, {
    getComponent(location, cb) {
        require.ensure(
            [],
            (require) => {
                cb(null, require('../../components/grid/v2/Services').default);
            },
            () => {
                // Adding fallback to prevent blank pages when the chunk is not available (I.E: after a release).
                // TODO: use a smarter way to get an updated chunk
                window.location.reload();
            },
            'services-grid');
    },

    async onComponentLoad (nextState, replace, callback, forcePlusBus = false) {
        const { params, location } = nextState;

        const refreshSearchFromUrl = async (targetLayout) => {
            const query = { ...location.query, targetLayout: targetLayout };
            let search = await SearchActions.loadFromParams(params, query);
            const isValidSearch = search.isValid();
            if (!isValidSearch) {
                replace(urls.location(PointStages.SEARCH, null, location.query));
            }

            const trip = CurrentTripStore.get();
            const isCurrentSearch = JourneyStore.isCurrentSearch(search);
            if (!isCurrentSearch) {
                try {
                    const user = UserStore.getCurrent();
                    await SearchActions.search({search, user});
                    if (trip.isPlusBusAvailable()) {
                        TripActions.loadPlusBusAvailability(trip);
                    }
                    openInAppVersionEndingModal();
                    _.defer(callback);
                } catch (e) {
                    replace(urls.location(PointStages.SEARCH, null, location.query));
                    if (e instanceof InvalidSearchError) {
                        console.error(e);
                    } else {
                        throw e;
                    }
                }
            } else {
                if (trip.isPlusBusAvailable() && forcePlusBus) {
                    TripActions.loadPlusBusAvailability(trip);
                }
                openInAppVersionEndingModal();
            }
            _.defer(callback);
        };

        refreshSearchFromUrl(JourneyPlannerLayoutTrackingName[JourneyPlannerLayout.GRID]);
    },

    async onEnter (nextState, replace, callback) {
        this.onComponentLoad(nextState, replace, callback, true);
    },

    async onChange (prevState, nextState, replace, callback) {
        this.onComponentLoad(nextState, replace, callback);
    }
});
